import { createSlice } from "@reduxjs/toolkit";

export const servicesSlice = createSlice({
  name: "servicesInformation",
  initialState: {
    services: [],
  },
  reducers: {
    setServices: (state, action) => {
      state.services = action.payload;
    },
  },
});

export const { setServices } = servicesSlice.actions;

export default servicesSlice.reducer;

